import { observer } from "mobx-react";
import './index.css';
import { useLocation, useNavigate } from "react-router";
import VestelHeader from "../../components/VestelHeader";
import DashboardSideBar from "../../components/DashboardSideBar";
import { useContext, useEffect, useState } from "react";
import strings from "../../localization";
import { getUrlValue, parseQueryString } from "../../helpers/functions";
import CallStore from "../../stores/CallStore";
import SessionLogsPagination from "../../components/SessionLogsPagination";
import SessionLogsItem from "../../components/SessionLogsItem";
import CustomSelect from "../../components/CustomSelect";
import { bigPhoneIcon, cameraIcon, phoneIcon, sortCallsIcon, videoCameraIcon } from "../../assets";
import 'react-phone-number-input/style.css'
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { ModalAlertContext } from "../../contexts/ModalAlertContext";
import SessionLogsFilter from "../../components/SessionLogsFilter";

const StartVideoCallModal = ({ onClose }) => {

  const { showModalAlert, closeModalAlert } = useContext(ModalAlertContext);
  const navigate = useNavigate();

  const [customerNumber, setCustomerNumber] = useState('');

  const handleCall = () => {
    localStorage.removeItem('callToken');
    localStorage.removeItem('slug');
    localStorage.removeItem('pin');

    CallStore.createCall(`${customerNumber}`).then((response) => {
      if (response.success) {
        setCustomerNumber('');
        navigate(response.data.path);
        CallStore.setCall(response.data);
      } else {
        showModalAlert(
          {
            title: strings.error,
            message: response.message,
            confirmText: strings.ok,
            type: "error",
            onConfirm: () => { closeModalAlert() },
            onCancel: null
          });
      }
    });
  }

  return <div className="start-video-call-modal">
    <div className="start-video-call-modal-overlay" ></div>
    <div className="start-video-call-modal-content">
      <div className="start-video-call-modal-content-top">
        <img className="start-video-call-modal-content-top-img" src={bigPhoneIcon} alt="video-camera" />
        <span className="start-video-call-modal-content-top-title">{strings.enterTheCustomerPhoneNumber}</span>
        <div className="start-video-call-modal-content-top-input-group">
          <span>
            Customer Phone number <i>*</i>
          </span>
          <div className="start-video-call-modal-content-top-input-group-input">
            <PhoneInputWithCountrySelect
              international
              defaultCountry="TR"
              flagComponent={(props) => {
                const uri = props.flagUrl.replace('{XX}', props.country);
                return <div className="start-video-call-modal-content-top-input-group-input-flag">
                  <span>{props.country}</span>
                  <img src={uri} alt="tr" />
                </div>
              }}
              value={customerNumber}
              onChange={setCustomerNumber}
              placeholder={strings.phone}
            />
          </div>
        </div>
      </div>
      <div className="start-video-call-modal-content-bottom">
        <button className="button-text-cta" onClick={onClose}>
          <span>{strings.cancel}</span>
        </button>
        <button className="button-cta-secondary button-cta-secondary-large" onClick={handleCall}>
          <img src={phoneIcon} alt="phone" />
          <span>{strings.call}</span>
        </button>
      </div>
    </div>
  </div >
}

const StartVideoCall = ({ onClick }) => {
  return <div className="start-video-call">
    <button className="button-cta-secondary button-cta-medium" onClick={onClick}>
      <img src={videoCameraIcon} alt="video-camera" style={{ filter: 'invert(1)' }} />
      <span>{strings.startVideoCall}</span>
    </button>
  </div >
}

const SessionLogsView = () => {


  const navigate = useNavigate();
  const query = useLocation();
  const { showPleaseWait, closePleaseWait, showModalAlert, closeModalAlert } = useContext(ModalAlertContext);


  const [isStartVideoCallModalOpen, setIsStartVideoCallModalOpen] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [calls, setCalls] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    total: 0,
    pages: 0,
    limit: 10
  });

  const getCalls = async () => {
    showPleaseWait({ title: strings.pleaseWait, message: strings.contentIsLoading, customStyle: { alignItems: 'center' }, customContentStyle: { width: 400 } });
    const response = await CallStore.getCalls();
    closePleaseWait();

    if (response.success) {
      setCalls(response.data.calls);
      setPagination(response.data.pagination);
      return response;
    } else {
      showModalAlert({
        title: strings.error,
        message: response.message,
        confirmText: strings.ok,
        type: "error",
        onConfirm: () => {
          closeModalAlert();
        },
        onCancel: null
      });
    }
  }


  useEffect(() => {
    const _page = getUrlValue(query.search, 'page') || 1;
    const _limit = getUrlValue(query.search, 'limit') || 10;
    const queries = parseQueryString(window.location.search);
    if (_page) {
      setPagination({ ...pagination, page: _page });
    }
    if (_limit) {
      setPagination({ ...pagination, limit: _limit });
    }
    CallStore.setFilters({ page: _page, limit: _limit, ...queries })
    getCalls();
    setIsReady(true);
  }, []);


  const [sort, setSort] = useState('ASC');

  const handleSortChange = (value) => {
    setSort(value);
    CallStore.setFilters({ page: pagination.page, limit: pagination.limit, sortKey: 'createdAt', sortValue: sort })
    getCalls();
  }

  const sortList = [
    {
      key: 'DESC',
      name: strings.timeFirstListed
    },
    {
      key: 'ASC',
      name: strings.timeLastListed
    }
  ]

  return <div className="dashboard-layout-view session-logs-view">
    <VestelHeader children={<StartVideoCall onClick={() => setIsStartVideoCallModalOpen(true)} />} />
    <div className="dashboard-layout-view-content">
      <DashboardSideBar />
      <div className="dashboard-layout-view-content-right">
        <div className="dashboard-layout-view-content-right-header">
          <span>{strings.dashboard}</span>
          <CustomSelect icon={sortCallsIcon} list={sortList} value={sort} setValue={handleSortChange} />
        </div>
        <SessionLogsFilter getCalls={getCalls} pagination={pagination} />
        <div className="dashboard-layout-view-content-scroll-body">
          {calls.map((call) => <SessionLogsItem key={call._id} call={call} />)}
        </div>

        <div className="dashboard-layout-view-content-bottom">
          {isReady && <SessionLogsPagination pagination={pagination} getCalls={getCalls} />}
        </div>

      </div>
    </div>
    {isStartVideoCallModalOpen && <StartVideoCallModal onClose={() => setIsStartVideoCallModalOpen(false)} />}
  </div>
};

export default observer(SessionLogsView);
